var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveGroupsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.50017 7.91667H17.5002M7.40167 3.75H3.33333C2.87333 3.75 2.5 4.12333 2.5 4.58333V15.4167C2.5 15.8767 2.87333 16.25 3.33333 16.25H16.6667C17.1267 16.25 17.5 15.8767 17.5 15.4167V6.25C17.5 5.79 17.1267 5.41667 16.6667 5.41667H10.0983C9.5275 5.41667 9.00583 5.09417 8.75 4.58333C8.495 4.0725 7.97333 3.75 7.40167 3.75Z",
    stroke: "#00E2D1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveGroupsIcon);
export default __webpack_public_path__ + "static/media/active-groups-icon.108490712e3eb04105d1d9ddc4b7bf4e.svg";
export { ForwardRef as ReactComponent };